import {
  AlbumAvailabilityByTerritory,
  Artist,
  AvailabilityStatus,
  Identifier,
  Patch,
} from '@hooks/useAlbumInfo/types';

// matches BE: https://ghe.spotify.net/atlas-system/atlas-view/blob/master/src/main/proto/v2/track.proto#L27
export enum TrackMediaType {
  MEDIA_TYPE_UNKNOWN = 'MEDIA_TYPE_UNKNOWN',
  MEDIA_TYPE_AUDIO = 'MEDIA_TYPE_AUDIO',
  MEDIA_TYPE_VIDEO = 'MEDIA_TYPE_VIDEO',
}

export enum DecisionReason {
  UNKNOWN = 'UNKNOWN',
  ASSOCIATION_PATCH = 'ASSOCIATION_PATCH',
  PARTIAL_BLOCK_PATCH = 'PARTIAL_BLOCK_PATCH',
  TOTAL_BLOCK_PATCH = 'TOTAL_BLOCK_PATCH',
  RELATED_RELEASE_MATCHES = 'RELATED_RELEASE_MATCHES',
  NO_RELATED_RELEASE_CANDIDATES = 'NO_RELATED_RELEASE_CANDIDATES',
  TRACK_NAME_MISMATCH = 'TRACK_NAME_MISMATCH',
  TRACK_LICENSOR_MISMATCH = 'TRACK_LICENSOR_MISMATCH',
  TRACK_ARTIST_MISMATCH = 'TRACK_ARTIST_MISMATCH',
  TRACK_EXPLICITNESS_MISMATCH = 'TRACK_EXPLICITNESS_MISMATCH',
  TRACK_DURATION_MISMATCH = 'TRACK_DURATION_MISMATCH',
}

export type TrackDetails = {
  uri: string;
  url: string;
  artists: Artist[];
  name: string;
  duration: number;
  discNumber: number;
  trackNumber: number;
  isrc: string;
  mediaType: TrackMediaType;
  explicitLyrics: boolean;
  prereleaseVisibilityDate: string;
  identifiers: Identifier[];
  associatedTrack: AssociatedTrack;
  relatedIdentifiers: Identifier[];
};

export type AssociatedTrackDetails = {
  albumCoverArtImage: string;
  discNumber: number;
  duration: number;
  isrc: string;
  mediaType: TrackMediaType;
  name: string;
  originalAlbumReleaseDate: string;
  trackNumber: number;
  explicitLyrics: boolean;
  artists: Artist[];
  licensorName: string;
};

export type VideoAssociation = {
  videoTrackUri: string;
  audioTrackUri: string;
  createdAt: string;
  licensorId: string;
  isAssociated: boolean;
  decisionReason: DecisionReason[];
  deliveryId: string;
};

export type AssociatedTrack = {
  trackUri: string;
  trackUrl: string;
  albumUri: string;
  trackDetails: AssociatedTrackDetails;
  videoAssociation: VideoAssociation;
};

export type AvailabilityDetails = {
  deliveredStart: string;
  deliveredEnd: string;
  effectiveStart: string;
  effectiveEnd: string;
  status: AvailabilityStatus;
  patches: Patch[];
};

export type TrackDetailsResponse = {
  effectiveData: TrackDetails;
  availability: AlbumAvailabilityByTerritory;
};

export type MultiTrackDetailsResponse = {
  deliveredData: TrackDetails;
  effectiveData: TrackDetails;
  availability: AlbumAvailabilityByTerritory;
};
